import { ICategories, IEntities, IKeyTopics } from '../services/common/nlp/klangoo-config'
import { Utils } from './common'

/**
 * Klangoo helper functions.
 */
export const KlangooUtils = {
    /**
     * Filters and converts Klangoo entity (only token)
     * array of object into string
     *
     * @param {array}
     * @param {number}
     * @param {array}
     * @return {string}
     */

    stringifyFilteredEntities(entities: IEntities[], rank?: string[], threshold?: number): string[] {
        if (entities) {
            if (rank && threshold) {
                return entities
                    .filter((item) => rank.indexOf(item.rank) > -1 && item.score > threshold)
                    .map((item) => Utils.decodeHtmlEntity(item.token))
            } else {
                return entities.map((item) => Utils.decodeHtmlEntity(
                    `${item.type}>${item.subtype}>${item.token},${item.score},${item.rank}`))
            }
        }
        return []
    },

    /**
     * Converts Klangoo KeyTopics array of object into string
     *
     * @param {array}
     * @param {number}
     *
     * @return {string}
     */

    stringifyFilteredKeytopics(keyTopics: IKeyTopics[], threshold?: number): string[] {
        if (keyTopics) {
            if (threshold) {
                return keyTopics
                    .filter((item) => item.score > threshold)
                    .map((item) => Utils.decodeHtmlEntity(item.text))
            } else {
                return keyTopics.map((item) => Utils.decodeHtmlEntity(`${item.text},${item.score}`))
            }
        }
        return []
    },

    /**
     * Converts Klangoo categories array of object into string
     *
     * @param {array}
     * @param {number}
     *
     * @return {string}
     */

    stringifyFilteredCategories(categories: ICategories[], threshold: number): string[] {
        if (categories) {
            const mainCategories = categories
                .filter((item) => item.score > threshold)
                .map((category) => Utils.decodeHtmlEntity(category.name))

            const subCategories = categories
                .filter((item) => item.score)
                .map((category) => {
                    if (category.specificCategories) {
                        return category.specificCategories
                            .filter((item) => item.score)
                            .map((item) => Utils.decodeHtmlEntity(item.name))
                    }
                    return []
                })
            return [...new Set([...mainCategories, ...subCategories[0]])]
        }
        return []
    }
}
